import styled from 'styled-components';
import Box from '@rsos/base-components/Box';

export const CopyButton = styled(Box).attrs(({ isActive }) => ({
  position: 'relative',
  horizontal: true,
  align: 'center',
  justify: 'center',
  backgroundColor: isActive ? 'lightLineDivider' : 'transparent',
  width: '65px',
  marginRight: '12px',
  padding: '5px',
  color: 'secondaryLink',
  cursor: 'pointer',
  transition: 'background-color 0.3s',
  borderRadius: '5px',
}))`
  &:hover {
    background-color: ${({ theme }) => theme.colors.lightLineDivider};
  }
`;
